<div class="w-[16.75rem] bg-primary p-4 sidenav">
  <div class="text-center mb-8" *ngIf="user?.type === 'user'">
    <div class="flex justify-center" (mouseenter)="pfpHover()" (mouseleave)="pfpHover()"  >
      @if(studentData?.profileImage) {
      <img #pfpElement [ngClass]="{'blur-sm':blurPfp }" class="rounded-full mb-5 object-cover  w-[5.75rem] h-[5.75rem]  "  
        [src]="pfpImage" alt="">

      
      @if(!isPfpEdit) {
        <div class="absolute inset-x-0 m-8 md:m-4 flex flex-col items-center">
          <div>
            <input id="upload_pfp" type="file" class="w-10 h-10 opacity-0 cursor-pointer "
              (change)="uploadVeteranPfp($event)" />
            <label for="upload_pfp" class="absolute flex justify-center cursor-pointer  inset-0 z-0">
              <i class="pi pi-image " [ngClass]="{'opacity-0':!blurPfp}" style="font-size: 1.5rem; color: black;"></i>
            </label>
  
            <app-typography for="upload_pfp" class="cursor-pointer" [ngClass]="{'opacity-0':!blurPfp}" [variant]="'extraSmall'">Change Photo</app-typography>
  
          </div>
        </div>
      } @else {
        
      }
    }
      
      <!-- } @else {
      <p-avatar styleClass="mr-2 mb-5 w-[5.75rem] h-[5.75rem] border-4 border-neutral-500"
        shape="circle"></p-avatar>
      } -->
  
    </div>

    @if(isPfpEdit){
      <div class="flex justify-center gap-2 pb-2">
        <app-button [label]="'Upload'" [variant]="'outlined'" [severity]="'info'" (sendClick)="saveVeteranPfp()" [loading]="uploading" [size]="'small'"></app-button>

        <app-button [label]="'Cancel'" [variant]="'outlined'" [severity]="'warning'"
          (sendClick)="cancelPfpUpload()" [size]="'small'"></app-button>

      </div>
    }
    

      
    <app-typography overrideClass="mb-2" [color]="'white'" [component]="'h1'" [variant]="'header'">{{ studentData?.firstName
      }}  {{studentData?.middleName}}  {{studentData?.lastName }}</app-typography>
    <app-typography color="white" variant="smallBody">{{
      studentData?.militaryInfo
      }}</app-typography>
  </div>

  <!-- <toaster></toaster> -->
  <p-panelMenu styleClass="sidenav-menu" [model]="items"></p-panelMenu>
  <!-- <app-menu styleClass="bg-primary" [items]="items"> </app-menu> -->
</div>